import React, { useEffect, useRef } from "react";
import { Modal, ModalProps, Row, Spinner } from "react-bootstrap";
import Close from "../compoment/icon/Close";
import { formatStationName } from "../utils";
import { Heart } from "react-feather";
import { persistFavouriteArtSavedLocally } from "../services/favouritesService";

interface MainMenuModalProps extends ModalProps {
  onHide: () => void;
  favourites: any;
  onSelect?: (favourite: any) => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}

const FavouriteArtModal = ({
  favourites,
  onSelect,
  onHide,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore,
  ...modalProps
}: MainMenuModalProps) => {
  const handleFavourite = (favourite: any) => {
    localStorage.setItem("favouriteImg", favourite.imageUrl);
    // Gallery pick is already a favourite → isAlreadySaved = true
    persistFavouriteArtSavedLocally(favourite.imageUrl);
    window.dispatchEvent(new Event("favouriteImgUpdated"));
    onSelect?.(favourite);
    onHide();
  };

  const loadMoreLockRef = useRef(false);

  useEffect(() => {
    if (!isLoadingMore) loadMoreLockRef.current = false;
  }, [isLoadingMore]);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    if (!hasMore || isLoadingMore || !onLoadMore || loadMoreLockRef.current) return;
    const target = event.currentTarget;
    const remaining = target.scrollHeight - target.scrollTop - target.clientHeight;
    if (remaining <= 80) {
      loadMoreLockRef.current = true;
      onLoadMore();
    }
  };

  return (
    <Modal
      {...modalProps}
      className={`favouriteArtModal`}
      backdropClassName="favouriteArtModalBackdrop"
      keyboard={false}
      centered
      scrollable={false}
      onHide={onHide}
    >
      <Modal.Body onScroll={handleScroll}>
        <div className="mb-3">
          <div className="heading">My Gallery</div>
          <button
            type="button"
            className="favouriteArtClose"
            aria-label="Close favorites"
            onClick={onHide}
          >
            <Close />
          </button>
        </div>
        <Row className="favouritesGrid g-3">
          {Array.isArray(favourites) && favourites.length > 0 ? (
            favourites.map((favourite: any) => (
              <div key={favourite.id} className="favouriteCol" onClick={() => handleFavourite(favourite)}>
                <div className="templateSingleItemAdd">
                  <div className="imageSection">
                    <div className="stationType">{formatStationName(favourite?.type)}</div>
                    <img
                      src={favourite.imageUrl}
                      alt={`Gallery ${favourite.type}`}
                      className="templateImg"
                      onError={(e) => {
                        (e.target as HTMLImageElement).style.display = "none";
                      }}
                    />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="favouriteArtEmpty">
              <div className="favouriteArtEmptyIcon" aria-hidden="true">
                <Heart />
              </div>
              <div className="favouriteArtEmptyTitle">No gallery yet</div>
              <div className="favouriteArtEmptyText">
                Your saved artwork will appear here.
              </div>
            </div>
          )}
        </Row>
        {isLoadingMore && (
          <div className="d-flex justify-content-center py-3">
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FavouriteArtModal;
